import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/**
 * Schema for marketing agent split info response
 */
const marketingAgentSplitInfoSchema_ = z.object({
  /** Whether the split/test is currently active */
  isActive: z.boolean(),
  /** Date when the test started */
  startDate: zExt.instant(),
  /** Date when the test ended (null if still running) */
  endDate: zExt.instant().nullable(),
  /** Traffic percentage allocated to variant (0-100) */
  variantTrafficPercentage: z.number().min(0).max(100),
});
export const marketingAgentSplitInfoSchema: z.ZodType<MarketingAgentSplitInfo> =
  marketingAgentSplitInfoSchema_;
export interface MarketingAgentSplitInfo
  extends z.infer<typeof marketingAgentSplitInfoSchema_> {}

export const getMarketingAgentSplitInfo = {
  name: "getMarketingAgentSplitInfo" as const,
  input: z.object({ splitId: z.string().optional() }),
  output: marketingAgentSplitInfoSchema.nullable(),
};
